import { useNavigate } from "react-router-dom";
import Et3Button from "../../core/et3-button";
import ET3Div from "../../core/et3-div";
import { withLiteObserverAndTheme } from "../../core/et3-enhanced-render";
import getCoreLoginStore from "../../stores/core/core-login-store";
import getCoreUIStore from "../../stores/core/core-ui-store";

const ProfileDropdownButtons = withLiteObserverAndTheme((props) => {
  const { theme } = props;
  const { colors } = theme;
  const navigate = useNavigate();

  return (
    <ET3Div
      isScrollable={false}
      isExtendable={false}
      fDirection="column"
      justifyContent="space-between"
      alignItems="center"
      withShadow={false}
      width={330}
      height={100}
      color={colors.all.transparent}
      style={{
        display: "flex"
      }}
      onClick={() => {}}
    >
      <Et3Button
        onClick={() => {
          getCoreUIStore().isProfileDropdownVisible.set(false);
          navigate({ pathname: "/CSR/changePassword" });
        }}
        isEnabled={true}
        size="MEDIUM"
        text="CHANGE_PASSWORD"
        type="APPROVE"
      />
      <Et3Button
        onClick={() => getCoreLoginStore().signOutHandler()}
        isEnabled={true}
        size="MEDIUM"
        text="SIGN_OUT"
        type="REJECT"
      />
    </ET3Div>
  );
});
export default ProfileDropdownButtons;
